<template>
    <div class="menu-dropdown-wrapper">
        <f-dropdown>
            <f-icon-button icon="ellipses" class="theme-svg" @click="toggleMenu" />
            <template v-slot:overlay>
                <f-menu :items="toolbarMenuItems">
                    <template v-slot:item="{ item }">
                        <span @click="handleAction(item)" class="action-item">
                            {{ item.label }}
                        </span>
                    </template>
                </f-menu>
            </template>
        </f-dropdown>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Localizer } from "@/api/Localizer";
import { mapMutations } from "vuex";
import { IActionToolbarDropdown, STATUS } from "./LandscapeManagementInterfaces";

export default defineComponent({
    props: {
        params: Object,
    },
    data() {
        return {
            toolbarMenuItems: [] as Array<IActionToolbarDropdown>,
            localizer: new Localizer(this.$store),
        };
    },
    mounted() {
        if (this.params?.data?.status === STATUS.DEPLOYING) {
            this.toolbarMenuItems = [
                { label: this.localizer.Localize("LandscapeManagement_Cancel_Deployment"), key: "cancel-deployment" },
            ];
        } else {
            this.toolbarMenuItems = [
                { label: this.localizer.Localize("LandscapeManagement_Edit_Changeset"), key: "edit" },
                { label: this.localizer.Localize("LandscapeManagement_Delete_Changeset"), key: "delete" },
            ];
        }
    },
    methods: {
        ...mapMutations('alm', [
            'setActionableChangeset'
        ]),
        toggleMenu(event: Event) {
            event.stopPropagation();
            this.setActionableChangeset(this.params?.data);
        },
        async handleAction(type: any) {
            switch (type.key) {
                case "edit":
                    this.params?.onEdit();
                    break;
                case "export":
                    this.params?.onExport(this.params?.data);
                    break;
                case "duplicate":
                    this.params?.onDuplicate(this.params?.data);
                    break;
                case "delete":
                    this.params?.onDelete();
                    break;
                case "cancel-deployment":
                    this.params?.onCancelDeployment(this.params?.data);
                    break;
            }
        }
    },
});
</script>

<style>
.p-tieredmenu:has(.action-item) {
    padding: 8px;
    color: var(--foreground-primary);
}

.p-tieredmenu:has(.action-item) .p-menuitem:has(.action-item) {
    margin: 0;
}

.p-menuitem:has(.action-item) .p-menuitem-content:has(.action-item) {
    padding: 0;
    line-height: normal;
    height: auto;
}

.action-item {
    width: 100%;
    padding: 12px 8px;
}
</style>
